/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import authService from "../auth/AuthorizeService";
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ServiceConfiguration {
    
}

export class BaseService {
    private readonly config: ServiceConfiguration;
    
    constructor(config: ServiceConfiguration) {
        this.config = config;
    }

    protected transformOptions = (options: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
        return new Promise<AxiosRequestConfig>(resolve => {
            authService.getAccessToken().then(token => {
                if (!!token && BaseService.isSameOriginUrl(options)) {
                    options.headers = {
                        ...options.headers,
                        'Authorization': `Bearer ${token}`
                    };
                }
                resolve(options);
            });
        });
    };

    protected transformResult(url: string, response: AxiosResponse, processor: (response: AxiosResponse) => any) {
        // TODO: Return own result or throw exception to change default processing behavior, 
        // or call processor function to run the default processing logic

        return processor(response);
    }

    private static isSameOriginUrl(req: any) {
        // It's an absolute url with the same origin.
        if (req.url.startsWith(`${window.location.origin}/`)) {
            return true;
        }

        // It's a protocol relative url with the same origin.
        // For example: //www.example.com/api/Products
        if (req.url.startsWith(`//${window.location.host}/`)) {
            return true;
        }

        // It's a relative url like /api/Products
        if (/^\/[^\/].*/.test(req.url)) {
            return true;
        }

        // It's an absolute or protocol relative url that
        // doesn't have the same origin.
        return false;
    }
}

export interface IContactsService {
    getContacts(): Promise<GetContactsResponse>;
    createContact(contact: CreateContactCommand): Promise<CreateContactResponse>;
    getContact(id: string): Promise<GetContactResponse>;
}

export class ContactsService extends BaseService implements IContactsService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getContacts(  cancelToken?: CancelToken | undefined): Promise<GetContactsResponse> {
        let url_ = this.baseUrl + "/api/contacts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetContacts(_response));
        });
    }

    protected processGetContacts(response: AxiosResponse): Promise<GetContactsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetContactsResponse.fromJS(resultData200);
            return Promise.resolve<GetContactsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetContactsResponse>(<any>null);
    }

    createContact(contact: CreateContactCommand , cancelToken?: CancelToken | undefined): Promise<CreateContactResponse> {
        let url_ = this.baseUrl + "/api/contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contact);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateContact(_response));
        });
    }

    protected processCreateContact(response: AxiosResponse): Promise<CreateContactResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = CreateContactResponse.fromJS(resultData201);
            return Promise.resolve<CreateContactResponse>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateContactResponse>(<any>null);
    }

    getContact(id: string , cancelToken?: CancelToken | undefined): Promise<GetContactResponse> {
        let url_ = this.baseUrl + "/api/contacts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetContact(_response));
        });
    }

    protected processGetContact(response: AxiosResponse): Promise<GetContactResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetContactResponse.fromJS(resultData200);
            return Promise.resolve<GetContactResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetContactResponse>(<any>null);
    }
}

export interface IMaterialService {
    get(): Promise<Material[]>;
    importMaterials(csvFile: FileParameter | null | undefined): Promise<ImportMaterialsRow[]>;
    importMaterialAliases(file: FileParameter | null | undefined): Promise<MaterialAlias[]>;
}

export class MaterialService extends BaseService implements IMaterialService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(  cancelToken?: CancelToken | undefined): Promise<Material[]> {
        let url_ = this.baseUrl + "/api/material";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Material[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Material.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Material[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Material[]>(<any>null);
    }

    importMaterials(csvFile: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<ImportMaterialsRow[]> {
        let url_ = this.baseUrl + "/api/material/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (csvFile !== null && csvFile !== undefined)
            content_.append("csvFile", csvFile.data, csvFile.fileName ? csvFile.fileName : "csvFile");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImportMaterials(_response));
        });
    }

    protected processImportMaterials(response: AxiosResponse): Promise<ImportMaterialsRow[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImportMaterialsRow.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ImportMaterialsRow[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportMaterialsRow[]>(<any>null);
    }

    importMaterialAliases(file: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<MaterialAlias[]> {
        let url_ = this.baseUrl + "/api/material/import-aliases";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImportMaterialAliases(_response));
        });
    }

    protected processImportMaterialAliases(response: AxiosResponse): Promise<MaterialAlias[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialAlias.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MaterialAlias[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialAlias[]>(<any>null);
    }
}

export interface IMaterialProfileService {
    get(): Promise<MaterialProfile[]>;
}

export class MaterialProfileService extends BaseService implements IMaterialProfileService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(  cancelToken?: CancelToken | undefined): Promise<MaterialProfile[]> {
        let url_ = this.baseUrl + "/api/material-profiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<MaterialProfile[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialProfile.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MaterialProfile[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialProfile[]>(<any>null);
    }
}

export interface IMaterialSchedulesService {
    get(): Promise<Material[]>;
    create(): Promise<FileResponse>;
}

export class MaterialSchedulesService extends BaseService implements IMaterialSchedulesService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(  cancelToken?: CancelToken | undefined): Promise<Material[]> {
        let url_ = this.baseUrl + "/api/material-schedules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Material[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Material.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Material[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Material[]>(<any>null);
    }

    create(  cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/material-schedules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export interface IMaterialTypeService {
    get(): Promise<MaterialType[]>;
}

export class MaterialTypeService extends BaseService implements IMaterialTypeService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(  cancelToken?: CancelToken | undefined): Promise<MaterialType[]> {
        let url_ = this.baseUrl + "/api/material-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<MaterialType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MaterialType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialType[]>(<any>null);
    }
}

export interface IOidcConfigurationService {
    getClientRequestParameters(clientId: string | null): Promise<FileResponse>;
}

export class OidcConfigurationService extends BaseService implements IOidcConfigurationService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getClientRequestParameters(clientId: string | null , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/_configuration/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetClientRequestParameters(_response));
        });
    }

    protected processGetClientRequestParameters(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export interface IProjectAssemblyService {
    getAssemblies(projectId: string): Promise<ProjectAssembly[]>;
    getAssembly(assemblyId: string, projectId: string): Promise<ProjectAssembly>;
}

export class ProjectAssemblyService extends BaseService implements IProjectAssemblyService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAssemblies(projectId: string , cancelToken?: CancelToken | undefined): Promise<ProjectAssembly[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/assemblies";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAssemblies(_response));
        });
    }

    protected processGetAssemblies(response: AxiosResponse): Promise<ProjectAssembly[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectAssembly.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectAssembly[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectAssembly[]>(<any>null);
    }

    getAssembly(assemblyId: string, projectId: string , cancelToken?: CancelToken | undefined): Promise<ProjectAssembly> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/assemblies/{assemblyId}";
        if (assemblyId === undefined || assemblyId === null)
            throw new Error("The parameter 'assemblyId' must be defined.");
        url_ = url_.replace("{assemblyId}", encodeURIComponent("" + assemblyId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAssembly(_response));
        });
    }

    protected processGetAssembly(response: AxiosResponse): Promise<ProjectAssembly> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectAssembly.fromJS(resultData200);
            return Promise.resolve<ProjectAssembly>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectAssembly>(<any>null);
    }
}

export interface IProjectDefaultDirectoriesService {
    getDefaultDirectories(): Promise<DefaultDirectoryResult[]>;
    updateDefaultDirectory(id: string | undefined, name: string | null | undefined): Promise<FileResponse>;
    createDefaultDirectory(name: string | null | undefined): Promise<FileResponse>;
    deleteDefaultDirectory(directoryId: string | undefined): Promise<FileResponse>;
    setFabricationDrawingDirectory(directoryId: string | undefined): Promise<FileResponse>;
}

export class ProjectDefaultDirectoriesService extends BaseService implements IProjectDefaultDirectoriesService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getDefaultDirectories(  cancelToken?: CancelToken | undefined): Promise<DefaultDirectoryResult[]> {
        let url_ = this.baseUrl + "/api/settings/projects/default-directories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDefaultDirectories(_response));
        });
    }

    protected processGetDefaultDirectories(response: AxiosResponse): Promise<DefaultDirectoryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DefaultDirectoryResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DefaultDirectoryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultDirectoryResult[]>(<any>null);
    }

    updateDefaultDirectory(id: string | undefined, name: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/settings/projects/default-directories?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateDefaultDirectory(_response));
        });
    }

    protected processUpdateDefaultDirectory(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    createDefaultDirectory(name: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/settings/projects/default-directories?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateDefaultDirectory(_response));
        });
    }

    protected processCreateDefaultDirectory(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    deleteDefaultDirectory(directoryId: string | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/settings/projects/default-directories?";
        if (directoryId === null)
            throw new Error("The parameter 'directoryId' cannot be null.");
        else if (directoryId !== undefined)
            url_ += "directoryId=" + encodeURIComponent("" + directoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteDefaultDirectory(_response));
        });
    }

    protected processDeleteDefaultDirectory(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    setFabricationDrawingDirectory(directoryId: string | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/settings/projects/default-directories/set-fabrication-directory?";
        if (directoryId === null)
            throw new Error("The parameter 'directoryId' cannot be null.");
        else if (directoryId !== undefined)
            url_ += "directoryId=" + encodeURIComponent("" + directoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetFabricationDrawingDirectory(_response));
        });
    }

    protected processSetFabricationDrawingDirectory(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export interface IProjectFileDirectoriesService {
    deleteDirectory(directoryId: string | undefined, projectId: string): Promise<void>;
    getDirectories(projectId: string): Promise<GetDirectoriesResult>;
    createDirectory(projectId: string, parentDirectoryId: string | null | undefined, name: string | null | undefined): Promise<CreateDirectoryResult>;
    setCurrentFabricationDrawingDirectory(projectId: string, directoryId: string | undefined): Promise<FileResponse>;
}

export class ProjectFileDirectoriesService extends BaseService implements IProjectFileDirectoriesService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    deleteDirectory(directoryId: string | undefined, projectId: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/files/directories?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (directoryId === null)
            throw new Error("The parameter 'directoryId' cannot be null.");
        else if (directoryId !== undefined)
            url_ += "directoryId=" + encodeURIComponent("" + directoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteDirectory(_response));
        });
    }

    protected processDeleteDirectory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    getDirectories(projectId: string , cancelToken?: CancelToken | undefined): Promise<GetDirectoriesResult> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/files/directories";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDirectories(_response));
        });
    }

    protected processGetDirectories(response: AxiosResponse): Promise<GetDirectoriesResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDirectoriesResult.fromJS(resultData200);
            return Promise.resolve<GetDirectoriesResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDirectoriesResult>(<any>null);
    }

    createDirectory(projectId: string, parentDirectoryId: string | null | undefined, name: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<CreateDirectoryResult> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/files/directories?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (parentDirectoryId !== undefined && parentDirectoryId !== null)
            url_ += "parentDirectoryId=" + encodeURIComponent("" + parentDirectoryId) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateDirectory(_response));
        });
    }

    protected processCreateDirectory(response: AxiosResponse): Promise<CreateDirectoryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateDirectoryResult.fromJS(resultData200);
            return Promise.resolve<CreateDirectoryResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateDirectoryResult>(<any>null);
    }

    setCurrentFabricationDrawingDirectory(projectId: string, directoryId: string | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/files/directories/set-fabrication-directory?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (directoryId === null)
            throw new Error("The parameter 'directoryId' cannot be null.");
        else if (directoryId !== undefined)
            url_ += "directoryId=" + encodeURIComponent("" + directoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetCurrentFabricationDrawingDirectory(_response));
        });
    }

    protected processSetCurrentFabricationDrawingDirectory(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export interface IProjectFilesService {
    download(fileId: string, projectId: string): Promise<FileResponse>;
    open(fileId: string, projectId: string): Promise<FileResponse>;
    deleteFiles(projectId: string, request: DeleteFilesReqeuest): Promise<FileResponse>;
    getFiles(projectId: string, directoryId: string | null | undefined): Promise<ProjectFile[]>;
    uploadFile(projectId: string, directoryId: string | null | undefined, extractZip: boolean | undefined, file: FileParameter | null | undefined): Promise<string>;
    createDirectory(projectId: string, parentDirectoryId: string | null | undefined, name: string | null | undefined): Promise<string>;
    move(projectId: string, request: MoveFilesRequest): Promise<FileResponse>;
}

export class ProjectFilesService extends BaseService implements IProjectFilesService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    download(fileId: string, projectId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/files/download/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownload(_response));
        });
    }

    protected processDownload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    open(fileId: string, projectId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processOpen(_response));
        });
    }

    protected processOpen(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    deleteFiles(projectId: string, request: DeleteFilesReqeuest , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/files/delete";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteFiles(_response));
        });
    }

    protected processDeleteFiles(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    getFiles(projectId: string, directoryId: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<ProjectFile[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/files?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (directoryId !== undefined && directoryId !== null)
            url_ += "directoryId=" + encodeURIComponent("" + directoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFiles(_response));
        });
    }

    protected processGetFiles(response: AxiosResponse): Promise<ProjectFile[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectFile.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectFile[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectFile[]>(<any>null);
    }

    uploadFile(projectId: string, directoryId: string | null | undefined, extractZip: boolean | undefined, file: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/files?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (directoryId !== undefined && directoryId !== null)
            url_ += "directoryId=" + encodeURIComponent("" + directoryId) + "&";
        if (extractZip === null)
            throw new Error("The parameter 'extractZip' cannot be null.");
        else if (extractZip !== undefined)
            url_ += "extractZip=" + encodeURIComponent("" + extractZip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUploadFile(_response));
        });
    }

    protected processUploadFile(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    createDirectory(projectId: string, parentDirectoryId: string | null | undefined, name: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/files/directory?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (parentDirectoryId !== undefined && parentDirectoryId !== null)
            url_ += "parentDirectoryId=" + encodeURIComponent("" + parentDirectoryId) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateDirectory(_response));
        });
    }

    protected processCreateDirectory(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    move(projectId: string, request: MoveFilesRequest , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/files/move";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMove(_response));
        });
    }

    protected processMove(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export interface IProjectPartsService {
    import(projectId: string, file: FileParameter | null | undefined): Promise<ProjectPart[]>;
    getParts(projectId: string): Promise<ProjectPart[]>;
    importAssemblies(projectId: string, file: FileParameter | null | undefined): Promise<ProjectAssembly[]>;
    importAssemblyParts(projectId: string, file: FileParameter | null | undefined): Promise<any[]>;
}

export class ProjectPartsService extends BaseService implements IProjectPartsService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    import(projectId: string, file: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<ProjectPart[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/parts/import";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImport(_response));
        });
    }

    protected processImport(response: AxiosResponse): Promise<ProjectPart[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectPart.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectPart[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectPart[]>(<any>null);
    }

    getParts(projectId: string , cancelToken?: CancelToken | undefined): Promise<ProjectPart[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/parts";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetParts(_response));
        });
    }

    protected processGetParts(response: AxiosResponse): Promise<ProjectPart[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectPart.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectPart[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectPart[]>(<any>null);
    }

    importAssemblies(projectId: string, file: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<ProjectAssembly[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/parts/import-assemblies";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImportAssemblies(_response));
        });
    }

    protected processImportAssemblies(response: AxiosResponse): Promise<ProjectAssembly[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectAssembly.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectAssembly[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectAssembly[]>(<any>null);
    }

    importAssemblyParts(projectId: string, file: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<any[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/parts/import-assembly-parts";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImportAssemblyParts(_response));
        });
    }

    protected processImportAssemblyParts(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(<any>null);
    }
}

export interface IProjectsService {
    getProject(projectId: string): Promise<GetProjectResult>;
    editProject(projectId: string, request: EditProjectCommand): Promise<EditProjectResult>;
    getProjects(search: string | null | undefined): Promise<GetProjectsResult>;
    createProject(request: CreateProjectCommand): Promise<CreateProjectResult>;
    getStatuses(): Promise<ProjectStatus[]>;
    updateStatus(projectId: string, request: UpdateProjectStatusRequest): Promise<FileResponse>;
    updateAssignedUser(projectId: string, userId: string | undefined): Promise<FileResponse>;
}

export class ProjectsService extends BaseService implements IProjectsService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getProject(projectId: string , cancelToken?: CancelToken | undefined): Promise<GetProjectResult> {
        let url_ = this.baseUrl + "/api/projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProject(_response));
        });
    }

    protected processGetProject(response: AxiosResponse): Promise<GetProjectResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectResult.fromJS(resultData200);
            return Promise.resolve<GetProjectResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectResult>(<any>null);
    }

    editProject(projectId: string, request: EditProjectCommand , cancelToken?: CancelToken | undefined): Promise<EditProjectResult> {
        let url_ = this.baseUrl + "/api/projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEditProject(_response));
        });
    }

    protected processEditProject(response: AxiosResponse): Promise<EditProjectResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditProjectResult.fromJS(resultData200);
            return Promise.resolve<EditProjectResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditProjectResult>(<any>null);
    }

    getProjects(search: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetProjectsResult> {
        let url_ = this.baseUrl + "/api/projects?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProjects(_response));
        });
    }

    protected processGetProjects(response: AxiosResponse): Promise<GetProjectsResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectsResult.fromJS(resultData200);
            return Promise.resolve<GetProjectsResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectsResult>(<any>null);
    }

    createProject(request: CreateProjectCommand , cancelToken?: CancelToken | undefined): Promise<CreateProjectResult> {
        let url_ = this.baseUrl + "/api/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateProject(_response));
        });
    }

    protected processCreateProject(response: AxiosResponse): Promise<CreateProjectResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateProjectResult.fromJS(resultData200);
            return Promise.resolve<CreateProjectResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateProjectResult>(<any>null);
    }

    getStatuses(  cancelToken?: CancelToken | undefined): Promise<ProjectStatus[]> {
        let url_ = this.baseUrl + "/api/projects/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStatuses(_response));
        });
    }

    protected processGetStatuses(response: AxiosResponse): Promise<ProjectStatus[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectStatus[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectStatus[]>(<any>null);
    }

    updateStatus(projectId: string, request: UpdateProjectStatusRequest , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/update-status";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStatus(_response));
        });
    }

    protected processUpdateStatus(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    updateAssignedUser(projectId: string, userId: string | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/update-assigned-user?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateAssignedUser(_response));
        });
    }

    protected processUpdateAssignedUser(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export interface IServicesService {
    get(): Promise<string>;
}

export class ServicesService extends BaseService implements IServicesService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(  cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }
}

export interface IStockService {
    get(materialId: string | null | undefined, stockLocationId: string | null | undefined, materialProfileId: string | null | undefined, materialTypeId: string | null | undefined): Promise<StockResult[]>;
    post(stockItem: AddStockDto): Promise<void>;
    getById(id: string): Promise<StockResult>;
    pull(stockId: string | undefined, qty: number | undefined): Promise<void>;
}

export class StockService extends BaseService implements IStockService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(materialId: string | null | undefined, stockLocationId: string | null | undefined, materialProfileId: string | null | undefined, materialTypeId: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<StockResult[]> {
        let url_ = this.baseUrl + "/api/stock?";
        if (materialId !== undefined && materialId !== null)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&";
        if (stockLocationId !== undefined && stockLocationId !== null)
            url_ += "stockLocationId=" + encodeURIComponent("" + stockLocationId) + "&";
        if (materialProfileId !== undefined && materialProfileId !== null)
            url_ += "materialProfileId=" + encodeURIComponent("" + materialProfileId) + "&";
        if (materialTypeId !== undefined && materialTypeId !== null)
            url_ += "materialTypeId=" + encodeURIComponent("" + materialTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StockResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StockResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StockResult[]>(<any>null);
    }

    post(stockItem: AddStockDto , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/stock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stockItem);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPost(_response));
        });
    }

    protected processPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    getById(id: string , cancelToken?: CancelToken | undefined): Promise<StockResult> {
        let url_ = this.baseUrl + "/api/stock/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetById(_response));
        });
    }

    protected processGetById(response: AxiosResponse): Promise<StockResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StockResult.fromJS(resultData200);
            return Promise.resolve<StockResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StockResult>(<any>null);
    }

    pull(stockId: string | undefined, qty: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/stock/pull?";
        if (stockId === null)
            throw new Error("The parameter 'stockId' cannot be null.");
        else if (stockId !== undefined)
            url_ += "stockId=" + encodeURIComponent("" + stockId) + "&";
        if (qty === null)
            throw new Error("The parameter 'qty' cannot be null.");
        else if (qty !== undefined)
            url_ += "qty=" + encodeURIComponent("" + qty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPull(_response));
        });
    }

    protected processPull(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export interface IStockLocationService {
    get(): Promise<StockLocation[]>;
    createStockLocation(request: CreateStockLocationRequest): Promise<FileResponse>;
    updateStockLocation(id: string, request: UpdateStockLocationRequest): Promise<FileResponse>;
    deleteStockLocation(id: string): Promise<StockLocation>;
}

export class StockLocationService extends BaseService implements IStockLocationService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(  cancelToken?: CancelToken | undefined): Promise<StockLocation[]> {
        let url_ = this.baseUrl + "/api/stock-locations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StockLocation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockLocation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StockLocation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StockLocation[]>(<any>null);
    }

    createStockLocation(request: CreateStockLocationRequest , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/stock-locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateStockLocation(_response));
        });
    }

    protected processCreateStockLocation(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    updateStockLocation(id: string, request: UpdateStockLocationRequest , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/stock-locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStockLocation(_response));
        });
    }

    protected processUpdateStockLocation(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    deleteStockLocation(id: string , cancelToken?: CancelToken | undefined): Promise<StockLocation> {
        let url_ = this.baseUrl + "/api/stock-locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteStockLocation(_response));
        });
    }

    protected processDeleteStockLocation(response: AxiosResponse): Promise<StockLocation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StockLocation.fromJS(resultData200);
            return Promise.resolve<StockLocation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StockLocation>(<any>null);
    }
}

export interface ISuppliersService {
    get(): Promise<Supplier[]>;
}

export class SuppliersService extends BaseService implements ISuppliersService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(  cancelToken?: CancelToken | undefined): Promise<Supplier[]> {
        let url_ = this.baseUrl + "/api/suppliers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<Supplier[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Supplier.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Supplier[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Supplier[]>(<any>null);
    }
}

export interface ISurfaceFinishService {
    get(): Promise<SurfaceFinish[]>;
    create(code: string | null | undefined, name: string | null | undefined, colours: Colour[] | null | undefined, isColoured: boolean | undefined): Promise<string>;
    createColour(id: string, name: string | null | undefined): Promise<FileResponse>;
    update(id: string, name: string | null | undefined, code: string | null | undefined): Promise<FileResponse>;
    delete(id: string): Promise<FileResponse>;
    updateColour(id: string, name: string | null | undefined): Promise<FileResponse>;
    deleteColour(id: string): Promise<FileResponse>;
}

export class SurfaceFinishService extends BaseService implements ISurfaceFinishService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(  cancelToken?: CancelToken | undefined): Promise<SurfaceFinish[]> {
        let url_ = this.baseUrl + "/api/surface-finishes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<SurfaceFinish[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurfaceFinish.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SurfaceFinish[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurfaceFinish[]>(<any>null);
    }

    create(code: string | null | undefined, name: string | null | undefined, colours: Colour[] | null | undefined, isColoured: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/surface-finishes?";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (colours !== undefined && colours !== null)
            colours && colours.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Colours[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (isColoured === null)
            throw new Error("The parameter 'isColoured' cannot be null.");
        else if (isColoured !== undefined)
            url_ += "IsColoured=" + encodeURIComponent("" + isColoured) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    createColour(id: string, name: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/surface-finishes/{id}/colour?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateColour(_response));
        });
    }

    protected processCreateColour(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    update(id: string, name: string | null | undefined, code: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/surface-finishes/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    delete(id: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/surface-finishes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    updateColour(id: string, name: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/surface-finishes/colour/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateColour(_response));
        });
    }

    protected processUpdateColour(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    deleteColour(id: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/surface-finishes/colour/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteColour(_response));
        });
    }

    protected processDeleteColour(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export interface ITasksService {
    getTasks(projectId: string | null | undefined): Promise<GetTasksResult>;
    createTask(request: CreateTaskCommand): Promise<CreateTaskCommandResult>;
    getTaskStatuses(): Promise<GetTaskStatusesResult>;
}

export class TasksService extends BaseService implements ITasksService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getTasks(projectId: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetTasksResult> {
        let url_ = this.baseUrl + "/api/tasks?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTasks(_response));
        });
    }

    protected processGetTasks(response: AxiosResponse): Promise<GetTasksResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTasksResult.fromJS(resultData200);
            return Promise.resolve<GetTasksResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTasksResult>(<any>null);
    }

    createTask(request: CreateTaskCommand , cancelToken?: CancelToken | undefined): Promise<CreateTaskCommandResult> {
        let url_ = this.baseUrl + "/api/tasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateTask(_response));
        });
    }

    protected processCreateTask(response: AxiosResponse): Promise<CreateTaskCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateTaskCommandResult.fromJS(resultData200);
            return Promise.resolve<CreateTaskCommandResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateTaskCommandResult>(<any>null);
    }

    getTaskStatuses(  cancelToken?: CancelToken | undefined): Promise<GetTaskStatusesResult> {
        let url_ = this.baseUrl + "/api/tasks/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTaskStatuses(_response));
        });
    }

    protected processGetTaskStatuses(response: AxiosResponse): Promise<GetTaskStatusesResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTaskStatusesResult.fromJS(resultData200);
            return Promise.resolve<GetTaskStatusesResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTaskStatusesResult>(<any>null);
    }
}

export interface ITenantService {
    createTenant(request: CreateTenantRequest): Promise<CreateTenantResult>;
}

export class TenantService extends BaseService implements ITenantService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    createTenant(request: CreateTenantRequest , cancelToken?: CancelToken | undefined): Promise<CreateTenantResult> {
        let url_ = this.baseUrl + "/api/tenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateTenant(_response));
        });
    }

    protected processCreateTenant(response: AxiosResponse): Promise<CreateTenantResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateTenantResult.fromJS(resultData200);
            return Promise.resolve<CreateTenantResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateTenantResult>(<any>null);
    }
}

export interface IUserService {
    getUser(userId: string): Promise<GetUserResult>;
    updateUser(userId: string, request: UpdateUserRequest): Promise<UpdateUserResult>;
    disableUser(userId: string): Promise<FileResponse>;
    getUsers(isActiveOnly: boolean | undefined): Promise<GetUsersResult>;
    enableUser(userId: string): Promise<FileResponse>;
    inviteUser(request: InviteUserRequest): Promise<InviteUserResponse>;
}

export class UserService extends BaseService implements IUserService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getUser(userId: string , cancelToken?: CancelToken | undefined): Promise<GetUserResult> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUser(_response));
        });
    }

    protected processGetUser(response: AxiosResponse): Promise<GetUserResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserResult.fromJS(resultData200);
            return Promise.resolve<GetUserResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserResult>(<any>null);
    }

    updateUser(userId: string, request: UpdateUserRequest , cancelToken?: CancelToken | undefined): Promise<UpdateUserResult> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateUser(_response));
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<UpdateUserResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateUserResult.fromJS(resultData200);
            return Promise.resolve<UpdateUserResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateUserResult>(<any>null);
    }

    disableUser(userId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDisableUser(_response));
        });
    }

    protected processDisableUser(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    getUsers(isActiveOnly: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<GetUsersResult> {
        let url_ = this.baseUrl + "/api/users?";
        if (isActiveOnly === null)
            throw new Error("The parameter 'isActiveOnly' cannot be null.");
        else if (isActiveOnly !== undefined)
            url_ += "isActiveOnly=" + encodeURIComponent("" + isActiveOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUsers(_response));
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<GetUsersResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUsersResult.fromJS(resultData200);
            return Promise.resolve<GetUsersResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUsersResult>(<any>null);
    }

    enableUser(userId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/enable";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEnableUser(_response));
        });
    }

    protected processEnableUser(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    inviteUser(request: InviteUserRequest , cancelToken?: CancelToken | undefined): Promise<InviteUserResponse> {
        let url_ = this.baseUrl + "/api/users/invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processInviteUser(_response));
        });
    }

    protected processInviteUser(response: AxiosResponse): Promise<InviteUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InviteUserResponse.fromJS(resultData200);
            return Promise.resolve<InviteUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InviteUserResponse>(<any>null);
    }
}

export interface IWorkLogService {
    getWorkLogEntries(projectId: string | null | undefined): Promise<WorkLogEntrySummary[]>;
    createWorkLogEntry(files: FileParameter[] | null | undefined, projectId: string | undefined, userIds: string[] | null | undefined, date: Date | undefined, startTime: string | undefined, endTime: string | undefined, details: string | null | undefined): Promise<CreateWorkLogEntryResponse>;
    getWorkDiaryEntry(id: string): Promise<GetWorkDiaryEntryResponse>;
    updateWorkDiaryEntry(id: string, files: FileParameter[] | null | undefined, projectId: string | undefined, userIds: string[] | null | undefined, date: Date | undefined, startTime: string | undefined, endTime: string | undefined, details: string | null | undefined): Promise<UpdateWorkDiaryEntryResponse>;
}

export class WorkLogService extends BaseService implements IWorkLogService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ServiceConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getWorkLogEntries(projectId: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<WorkLogEntrySummary[]> {
        let url_ = this.baseUrl + "/api/worklog?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetWorkLogEntries(_response));
        });
    }

    protected processGetWorkLogEntries(response: AxiosResponse): Promise<WorkLogEntrySummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkLogEntrySummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WorkLogEntrySummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkLogEntrySummary[]>(<any>null);
    }

    createWorkLogEntry(files: FileParameter[] | null | undefined, projectId: string | undefined, userIds: string[] | null | undefined, date: Date | undefined, startTime: string | undefined, endTime: string | undefined, details: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<CreateWorkLogEntryResponse> {
        let url_ = this.baseUrl + "/api/worklog?";
        if (files !== undefined && files !== null)
            files && files.forEach(item => { url_ += "files=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (projectId === null || projectId === undefined)
            throw new Error("The parameter 'projectId' cannot be null.");
        else
            content_.append("ProjectId", projectId.toString());
        if (userIds !== null && userIds !== undefined)
            userIds.forEach(item_ => content_.append("UserIds", item_.toString()));
        if (date === null || date === undefined)
            throw new Error("The parameter 'date' cannot be null.");
        else
            content_.append("Date", date.toJSON());
        if (startTime === null || startTime === undefined)
            throw new Error("The parameter 'startTime' cannot be null.");
        else
            content_.append("StartTime", startTime.toString());
        if (endTime === null || endTime === undefined)
            throw new Error("The parameter 'endTime' cannot be null.");
        else
            content_.append("EndTime", endTime.toString());
        if (details !== null && details !== undefined)
            content_.append("Details", details.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateWorkLogEntry(_response));
        });
    }

    protected processCreateWorkLogEntry(response: AxiosResponse): Promise<CreateWorkLogEntryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateWorkLogEntryResponse.fromJS(resultData200);
            return Promise.resolve<CreateWorkLogEntryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateWorkLogEntryResponse>(<any>null);
    }

    getWorkDiaryEntry(id: string , cancelToken?: CancelToken | undefined): Promise<GetWorkDiaryEntryResponse> {
        let url_ = this.baseUrl + "/api/worklog/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetWorkDiaryEntry(_response));
        });
    }

    protected processGetWorkDiaryEntry(response: AxiosResponse): Promise<GetWorkDiaryEntryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWorkDiaryEntryResponse.fromJS(resultData200);
            return Promise.resolve<GetWorkDiaryEntryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWorkDiaryEntryResponse>(<any>null);
    }

    updateWorkDiaryEntry(id: string, files: FileParameter[] | null | undefined, projectId: string | undefined, userIds: string[] | null | undefined, date: Date | undefined, startTime: string | undefined, endTime: string | undefined, details: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateWorkDiaryEntryResponse> {
        let url_ = this.baseUrl + "/api/worklog/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (files !== undefined && files !== null)
            files && files.forEach(item => { url_ += "files=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (projectId === null || projectId === undefined)
            throw new Error("The parameter 'projectId' cannot be null.");
        else
            content_.append("ProjectId", projectId.toString());
        if (userIds !== null && userIds !== undefined)
            userIds.forEach(item_ => content_.append("UserIds", item_.toString()));
        if (date === null || date === undefined)
            throw new Error("The parameter 'date' cannot be null.");
        else
            content_.append("Date", date.toJSON());
        if (startTime === null || startTime === undefined)
            throw new Error("The parameter 'startTime' cannot be null.");
        else
            content_.append("StartTime", startTime.toString());
        if (endTime === null || endTime === undefined)
            throw new Error("The parameter 'endTime' cannot be null.");
        else
            content_.append("EndTime", endTime.toString());
        if (details !== null && details !== undefined)
            content_.append("Details", details.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateWorkDiaryEntry(_response));
        });
    }

    protected processUpdateWorkDiaryEntry(response: AxiosResponse): Promise<UpdateWorkDiaryEntryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateWorkDiaryEntryResponse.fromJS(resultData200);
            return Promise.resolve<UpdateWorkDiaryEntryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateWorkDiaryEntryResponse>(<any>null);
    }
}

export class GetContactsResponse implements IGetContactsResponse {
    contacts?: ContactSummary[] | undefined;

    constructor(data?: IGetContactsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(ContactSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetContactsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetContactsResponse {
    contacts?: ContactSummary[] | undefined;
}

export class ContactSummary implements IContactSummary {
    id?: string;
    name?: string | undefined;

    constructor(data?: IContactSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ContactSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ContactSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IContactSummary {
    id?: string;
    name?: string | undefined;
}

export class CreateContactResponse implements ICreateContactResponse {
    contact?: Contact | undefined;

    constructor(data?: ICreateContactResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateContactResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateContactResponse {
    contact?: Contact | undefined;
}

export class Contact implements IContact {
    id?: string;
    isCustomer?: boolean;
    isSupplier?: boolean;
    name?: string | undefined;
    businessNumber?: string | undefined;
    taxNumber?: string | undefined;
    emailAddress?: string | undefined;
    addresses?: ContactAddress[] | undefined;
    phoneNumbers?: ContactPhoneNumber[] | undefined;
    contacts?: ContactPerson[] | undefined;
    xeroContactId?: string | undefined;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isCustomer = _data["isCustomer"];
            this.isSupplier = _data["isSupplier"];
            this.name = _data["name"];
            this.businessNumber = _data["businessNumber"];
            this.taxNumber = _data["taxNumber"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(ContactAddress.fromJS(item));
            }
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(ContactPhoneNumber.fromJS(item));
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(ContactPerson.fromJS(item));
            }
            this.xeroContactId = _data["xeroContactId"];
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isCustomer"] = this.isCustomer;
        data["isSupplier"] = this.isSupplier;
        data["name"] = this.name;
        data["businessNumber"] = this.businessNumber;
        data["taxNumber"] = this.taxNumber;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        data["xeroContactId"] = this.xeroContactId;
        return data;
    }
}

export interface IContact {
    id?: string;
    isCustomer?: boolean;
    isSupplier?: boolean;
    name?: string | undefined;
    businessNumber?: string | undefined;
    taxNumber?: string | undefined;
    emailAddress?: string | undefined;
    addresses?: ContactAddress[] | undefined;
    phoneNumbers?: ContactPhoneNumber[] | undefined;
    contacts?: ContactPerson[] | undefined;
    xeroContactId?: string | undefined;
}

export class ContactAddress implements IContactAddress {
    id?: string;
    contactId?: string;
    contact?: Contact | undefined;
    addressId?: string;
    address?: Address | undefined;

    constructor(data?: IContactAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
            this.addressId = _data["addressId"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactAddress {
        data = typeof data === 'object' ? data : {};
        let result = new ContactAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["addressId"] = this.addressId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContactAddress {
    id?: string;
    contactId?: string;
    contact?: Contact | undefined;
    addressId?: string;
    address?: Address | undefined;
}

export class Address implements IAddress {
    id?: string;
    line1?: string | undefined;
    line2?: string | undefined;
    suburb?: string | undefined;
    state?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;
    googlePlaceId?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.suburb = _data["suburb"];
            this.state = _data["state"];
            this.postCode = _data["postCode"];
            this.country = _data["country"];
            this.googlePlaceId = _data["googlePlaceId"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["suburb"] = this.suburb;
        data["state"] = this.state;
        data["postCode"] = this.postCode;
        data["country"] = this.country;
        data["googlePlaceId"] = this.googlePlaceId;
        return data;
    }
}

export interface IAddress {
    id?: string;
    line1?: string | undefined;
    line2?: string | undefined;
    suburb?: string | undefined;
    state?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;
    googlePlaceId?: string | undefined;
}

export class ContactPhoneNumber implements IContactPhoneNumber {
    id?: string;
    contactId?: string;
    contact?: Contact | undefined;
    phoneNumber?: string | undefined;
    areaCode?: string | undefined;
    countryCode?: string | undefined;

    constructor(data?: IContactPhoneNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.areaCode = _data["areaCode"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): ContactPhoneNumber {
        data = typeof data === 'object' ? data : {};
        let result = new ContactPhoneNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["areaCode"] = this.areaCode;
        data["countryCode"] = this.countryCode;
        return data;
    }
}

export interface IContactPhoneNumber {
    id?: string;
    contactId?: string;
    contact?: Contact | undefined;
    phoneNumber?: string | undefined;
    areaCode?: string | undefined;
    countryCode?: string | undefined;
}

export class ContactPerson implements IContactPerson {
    id?: string;
    contactId?: string;
    contact?: Contact | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    position?: string | undefined;
    isMainContactPerson?: boolean;

    constructor(data?: IContactPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.position = _data["position"];
            this.isMainContactPerson = _data["isMainContactPerson"];
        }
    }

    static fromJS(data: any): ContactPerson {
        data = typeof data === 'object' ? data : {};
        let result = new ContactPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["position"] = this.position;
        data["isMainContactPerson"] = this.isMainContactPerson;
        return data;
    }
}

export interface IContactPerson {
    id?: string;
    contactId?: string;
    contact?: Contact | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    position?: string | undefined;
    isMainContactPerson?: boolean;
}

export class CreateContactCommand implements ICreateContactCommand {
    name?: string | undefined;
    businessNumber?: string | undefined;
    taxNumber?: string | undefined;
    emailAddress?: string | undefined;
    isCustomer?: boolean;
    isSupplier?: boolean;

    constructor(data?: ICreateContactCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.businessNumber = _data["businessNumber"];
            this.taxNumber = _data["taxNumber"];
            this.emailAddress = _data["emailAddress"];
            this.isCustomer = _data["isCustomer"];
            this.isSupplier = _data["isSupplier"];
        }
    }

    static fromJS(data: any): CreateContactCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["businessNumber"] = this.businessNumber;
        data["taxNumber"] = this.taxNumber;
        data["emailAddress"] = this.emailAddress;
        data["isCustomer"] = this.isCustomer;
        data["isSupplier"] = this.isSupplier;
        return data;
    }
}

export interface ICreateContactCommand {
    name?: string | undefined;
    businessNumber?: string | undefined;
    taxNumber?: string | undefined;
    emailAddress?: string | undefined;
    isCustomer?: boolean;
    isSupplier?: boolean;
}

export class GetContactResponse implements IGetContactResponse {
    contact?: Contact | undefined;

    constructor(data?: IGetContactResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetContactResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetContactResponse {
    contact?: Contact | undefined;
}

/** A machine-readable format for specifying errors in HTTP API responses based on https://tools.ietf.org/html/rfc7807. */
export class ProblemDetails implements IProblemDetails {
    /** A URI reference [RFC3986] that identifies the problem type. This specification encourages that, when
dereferenced, it provide human-readable documentation for the problem type
(e.g., using HTML [W3C.REC-html5-20141028]).  When this member is not present, its value is assumed to be
"about:blank". */
    type?: string | undefined;
    /** A short, human-readable summary of the problem type.It SHOULD NOT change from occurrence to occurrence
of the problem, except for purposes of localization(e.g., using proactive content negotiation;
see[RFC7231], Section 3.4). */
    title?: string | undefined;
    /** The HTTP status code([RFC7231], Section 6) generated by the origin server for this occurrence of the problem. */
    status?: number | undefined;
    /** A human-readable explanation specific to this occurrence of the problem. */
    detail?: string | undefined;
    /** A URI reference that identifies the specific occurrence of the problem.It may or may not yield further information if dereferenced. */
    instance?: string | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

/** A machine-readable format for specifying errors in HTTP API responses based on https://tools.ietf.org/html/rfc7807. */
export interface IProblemDetails {
    /** A URI reference [RFC3986] that identifies the problem type. This specification encourages that, when
dereferenced, it provide human-readable documentation for the problem type
(e.g., using HTML [W3C.REC-html5-20141028]).  When this member is not present, its value is assumed to be
"about:blank". */
    type?: string | undefined;
    /** A short, human-readable summary of the problem type.It SHOULD NOT change from occurrence to occurrence
of the problem, except for purposes of localization(e.g., using proactive content negotiation;
see[RFC7231], Section 3.4). */
    title?: string | undefined;
    /** The HTTP status code([RFC7231], Section 6) generated by the origin server for this occurrence of the problem. */
    status?: number | undefined;
    /** A human-readable explanation specific to this occurrence of the problem. */
    detail?: string | undefined;
    /** A URI reference that identifies the specific occurrence of the problem.It may or may not yield further information if dereferenced. */
    instance?: string | undefined;
}

export class Material implements IMaterial {
    id?: string;
    materialProfileId?: string;
    materialProfile?: MaterialProfile | undefined;
    materialTypeId?: string;
    materialType?: MaterialType | undefined;
    code?: string | undefined;
    name?: string | undefined;
    weight?: number;
    isPlate?: boolean;
    thickness?: number | undefined;

    constructor(data?: IMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialProfileId = _data["materialProfileId"];
            this.materialProfile = _data["materialProfile"] ? MaterialProfile.fromJS(_data["materialProfile"]) : <any>undefined;
            this.materialTypeId = _data["materialTypeId"];
            this.materialType = _data["materialType"] ? MaterialType.fromJS(_data["materialType"]) : <any>undefined;
            this.code = _data["code"];
            this.name = _data["name"];
            this.weight = _data["weight"];
            this.isPlate = _data["isPlate"];
            this.thickness = _data["thickness"];
        }
    }

    static fromJS(data: any): Material {
        data = typeof data === 'object' ? data : {};
        let result = new Material();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialProfileId"] = this.materialProfileId;
        data["materialProfile"] = this.materialProfile ? this.materialProfile.toJSON() : <any>undefined;
        data["materialTypeId"] = this.materialTypeId;
        data["materialType"] = this.materialType ? this.materialType.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["name"] = this.name;
        data["weight"] = this.weight;
        data["isPlate"] = this.isPlate;
        data["thickness"] = this.thickness;
        return data;
    }
}

export interface IMaterial {
    id?: string;
    materialProfileId?: string;
    materialProfile?: MaterialProfile | undefined;
    materialTypeId?: string;
    materialType?: MaterialType | undefined;
    code?: string | undefined;
    name?: string | undefined;
    weight?: number;
    isPlate?: boolean;
    thickness?: number | undefined;
}

export class MaterialProfile implements IMaterialProfile {
    id?: string;
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: IMaterialProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MaterialProfile {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IMaterialProfile {
    id?: string;
    code?: string | undefined;
    name?: string | undefined;
}

export class MaterialType implements IMaterialType {
    id?: string;
    code?: string | undefined;
    name?: string | undefined;
    grades?: MaterialGrade[] | undefined;

    constructor(data?: IMaterialType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            if (Array.isArray(_data["grades"])) {
                this.grades = [] as any;
                for (let item of _data["grades"])
                    this.grades!.push(MaterialGrade.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaterialType {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        if (Array.isArray(this.grades)) {
            data["grades"] = [];
            for (let item of this.grades)
                data["grades"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMaterialType {
    id?: string;
    code?: string | undefined;
    name?: string | undefined;
    grades?: MaterialGrade[] | undefined;
}

export class MaterialGrade implements IMaterialGrade {
    id?: string;
    code?: string | undefined;
    name?: string | undefined;
    typeId?: string;
    type?: MaterialType | undefined;

    constructor(data?: IMaterialGrade) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? MaterialType.fromJS(_data["type"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MaterialGrade {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialGrade();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMaterialGrade {
    id?: string;
    code?: string | undefined;
    name?: string | undefined;
    typeId?: string;
    type?: MaterialType | undefined;
}

export class ImportMaterialsRow implements IImportMaterialsRow {
    material?: string | undefined;
    profileCode?: string | undefined;
    materialCode?: string | undefined;
    materialName?: string | undefined;
    weight?: number;
    isPlate?: boolean | undefined;
    plateThickness?: number | undefined;

    constructor(data?: IImportMaterialsRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.material = _data["material"];
            this.profileCode = _data["profileCode"];
            this.materialCode = _data["materialCode"];
            this.materialName = _data["materialName"];
            this.weight = _data["weight"];
            this.isPlate = _data["isPlate"];
            this.plateThickness = _data["plateThickness"];
        }
    }

    static fromJS(data: any): ImportMaterialsRow {
        data = typeof data === 'object' ? data : {};
        let result = new ImportMaterialsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["material"] = this.material;
        data["profileCode"] = this.profileCode;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["weight"] = this.weight;
        data["isPlate"] = this.isPlate;
        data["plateThickness"] = this.plateThickness;
        return data;
    }
}

export interface IImportMaterialsRow {
    material?: string | undefined;
    profileCode?: string | undefined;
    materialCode?: string | undefined;
    materialName?: string | undefined;
    weight?: number;
    isPlate?: boolean | undefined;
    plateThickness?: number | undefined;
}

export class MaterialAlias implements IMaterialAlias {
    id?: string;
    alias?: string | undefined;
    materialId?: string;
    material?: Material | undefined;

    constructor(data?: IMaterialAlias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alias = _data["alias"];
            this.materialId = _data["materialId"];
            this.material = _data["material"] ? Material.fromJS(_data["material"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MaterialAlias {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialAlias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alias"] = this.alias;
        data["materialId"] = this.materialId;
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMaterialAlias {
    id?: string;
    alias?: string | undefined;
    materialId?: string;
    material?: Material | undefined;
}

export class ProjectAssembly implements IProjectAssembly {
    id?: string;
    projectId?: string;
    project?: Project | undefined;
    mark?: string | undefined;
    qty?: number | undefined;
    parts?: AssemblyPartLine[] | undefined;
    surfaceFinishId?: string | undefined;
    surfaceFinish?: SurfaceFinish | undefined;
    mainPartMaterialId?: string | undefined;
    mainPartMaterial?: Material | undefined;
    length?: number | undefined;
    weight?: number | undefined;
    area?: number | undefined;

    constructor(data?: IProjectAssembly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.mark = _data["mark"];
            this.qty = _data["qty"];
            if (Array.isArray(_data["parts"])) {
                this.parts = [] as any;
                for (let item of _data["parts"])
                    this.parts!.push(AssemblyPartLine.fromJS(item));
            }
            this.surfaceFinishId = _data["surfaceFinishId"];
            this.surfaceFinish = _data["surfaceFinish"] ? SurfaceFinish.fromJS(_data["surfaceFinish"]) : <any>undefined;
            this.mainPartMaterialId = _data["mainPartMaterialId"];
            this.mainPartMaterial = _data["mainPartMaterial"] ? Material.fromJS(_data["mainPartMaterial"]) : <any>undefined;
            this.length = _data["length"];
            this.weight = _data["weight"];
            this.area = _data["area"];
        }
    }

    static fromJS(data: any): ProjectAssembly {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAssembly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["mark"] = this.mark;
        data["qty"] = this.qty;
        if (Array.isArray(this.parts)) {
            data["parts"] = [];
            for (let item of this.parts)
                data["parts"].push(item.toJSON());
        }
        data["surfaceFinishId"] = this.surfaceFinishId;
        data["surfaceFinish"] = this.surfaceFinish ? this.surfaceFinish.toJSON() : <any>undefined;
        data["mainPartMaterialId"] = this.mainPartMaterialId;
        data["mainPartMaterial"] = this.mainPartMaterial ? this.mainPartMaterial.toJSON() : <any>undefined;
        data["length"] = this.length;
        data["weight"] = this.weight;
        data["area"] = this.area;
        return data;
    }
}

export interface IProjectAssembly {
    id?: string;
    projectId?: string;
    project?: Project | undefined;
    mark?: string | undefined;
    qty?: number | undefined;
    parts?: AssemblyPartLine[] | undefined;
    surfaceFinishId?: string | undefined;
    surfaceFinish?: SurfaceFinish | undefined;
    mainPartMaterialId?: string | undefined;
    mainPartMaterial?: Material | undefined;
    length?: number | undefined;
    weight?: number | undefined;
    area?: number | undefined;
}

export abstract class AuditableEntity implements IAuditableEntity {
    created?: Date;
    createdByUserId?: string;
    lastModified?: Date | undefined;
    lastModifiedByUserId?: string;

    constructor(data?: IAuditableEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdByUserId = _data["createdByUserId"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedByUserId = _data["lastModifiedByUserId"];
        }
    }

    static fromJS(data: any): AuditableEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AuditableEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdByUserId"] = this.createdByUserId;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedByUserId"] = this.lastModifiedByUserId;
        return data;
    }
}

export interface IAuditableEntity {
    created?: Date;
    createdByUserId?: string;
    lastModified?: Date | undefined;
    lastModifiedByUserId?: string;
}

export class Project extends AuditableEntity implements IProject {
    id?: string;
    number?: string | undefined;
    name?: string | undefined;
    details?: string | undefined;
    addressId?: string | undefined;
    address?: Address | undefined;
    contacts?: ProjectContact[] | undefined;
    projectStatusId?: string | undefined;
    projectStatus?: ProjectStatus | undefined;
    currentFabricationDrawingDirectoryId?: string | undefined;
    currentFabricationDrawingDirectory?: ProjectFileDirectory | undefined;
    assignedToUserId?: string | undefined;
    assignedToUser?: ApplicationUser | undefined;
    customerId?: string | undefined;
    customer?: Contact | undefined;

    constructor(data?: IProject) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.name = _data["name"];
            this.details = _data["details"];
            this.addressId = _data["addressId"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(ProjectContact.fromJS(item));
            }
            this.projectStatusId = _data["projectStatusId"];
            this.projectStatus = _data["projectStatus"] ? ProjectStatus.fromJS(_data["projectStatus"]) : <any>undefined;
            this.currentFabricationDrawingDirectoryId = _data["currentFabricationDrawingDirectoryId"];
            this.currentFabricationDrawingDirectory = _data["currentFabricationDrawingDirectory"] ? ProjectFileDirectory.fromJS(_data["currentFabricationDrawingDirectory"]) : <any>undefined;
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUser = _data["assignedToUser"] ? ApplicationUser.fromJS(_data["assignedToUser"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Contact.fromJS(_data["customer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["name"] = this.name;
        data["details"] = this.details;
        data["addressId"] = this.addressId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        data["projectStatusId"] = this.projectStatusId;
        data["projectStatus"] = this.projectStatus ? this.projectStatus.toJSON() : <any>undefined;
        data["currentFabricationDrawingDirectoryId"] = this.currentFabricationDrawingDirectoryId;
        data["currentFabricationDrawingDirectory"] = this.currentFabricationDrawingDirectory ? this.currentFabricationDrawingDirectory.toJSON() : <any>undefined;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUser"] = this.assignedToUser ? this.assignedToUser.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProject extends IAuditableEntity {
    id?: string;
    number?: string | undefined;
    name?: string | undefined;
    details?: string | undefined;
    addressId?: string | undefined;
    address?: Address | undefined;
    contacts?: ProjectContact[] | undefined;
    projectStatusId?: string | undefined;
    projectStatus?: ProjectStatus | undefined;
    currentFabricationDrawingDirectoryId?: string | undefined;
    currentFabricationDrawingDirectory?: ProjectFileDirectory | undefined;
    assignedToUserId?: string | undefined;
    assignedToUser?: ApplicationUser | undefined;
    customerId?: string | undefined;
    customer?: Contact | undefined;
}

export class ProjectContact implements IProjectContact {
    id?: string;
    projectId?: string;
    project?: Project | undefined;
    positionInProject?: string | undefined;
    contact?: Contact | undefined;

    constructor(data?: IProjectContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.positionInProject = _data["positionInProject"];
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectContact {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["positionInProject"] = this.positionInProject;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectContact {
    id?: string;
    projectId?: string;
    project?: Project | undefined;
    positionInProject?: string | undefined;
    contact?: Contact | undefined;
}

export class ProjectStatus implements IProjectStatus {
    id?: string;
    name?: string | undefined;

    constructor(data?: IProjectStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProjectStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IProjectStatus {
    id?: string;
    name?: string | undefined;
}

export class ProjectFileDirectory implements IProjectFileDirectory {
    id?: string;
    projectId?: string;
    parentDirectoryId?: string | undefined;
    parentDirectory?: ProjectFileDirectory | undefined;
    name?: string | undefined;
    files?: ProjectFile[] | undefined;

    constructor(data?: IProjectFileDirectory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.parentDirectoryId = _data["parentDirectoryId"];
            this.parentDirectory = _data["parentDirectory"] ? ProjectFileDirectory.fromJS(_data["parentDirectory"]) : <any>undefined;
            this.name = _data["name"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(ProjectFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectFileDirectory {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFileDirectory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["parentDirectoryId"] = this.parentDirectoryId;
        data["parentDirectory"] = this.parentDirectory ? this.parentDirectory.toJSON() : <any>undefined;
        data["name"] = this.name;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectFileDirectory {
    id?: string;
    projectId?: string;
    parentDirectoryId?: string | undefined;
    parentDirectory?: ProjectFileDirectory | undefined;
    name?: string | undefined;
    files?: ProjectFile[] | undefined;
}

export class ProjectFile implements IProjectFile {
    id?: string;
    fileName?: string | undefined;
    projectId?: string;
    project?: Project | undefined;
    directoryId?: string | undefined;
    directory?: ProjectFileDirectory | undefined;

    constructor(data?: IProjectFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.directoryId = _data["directoryId"];
            this.directory = _data["directory"] ? ProjectFileDirectory.fromJS(_data["directory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectFile {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["directoryId"] = this.directoryId;
        data["directory"] = this.directory ? this.directory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectFile {
    id?: string;
    fileName?: string | undefined;
    projectId?: string;
    project?: Project | undefined;
    directoryId?: string | undefined;
    directory?: ProjectFileDirectory | undefined;
}

export class IdentityUserOfGuid implements IIdentityUserOfGuid {
    id?: string;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;

    constructor(data?: IIdentityUserOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
        }
    }

    static fromJS(data: any): IdentityUserOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data;
    }
}

export interface IIdentityUserOfGuid {
    id?: string;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
}

export class ApplicationUser extends IdentityUserOfGuid implements IApplicationUser {
    firstName?: string | undefined;
    lastName?: string | undefined;
    avatar?: string | undefined;
    deactivated?: boolean;
    tenantId?: string | undefined;
    tenant?: ApplicationTenant | undefined;

    constructor(data?: IApplicationUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.avatar = _data["avatar"];
            this.deactivated = _data["deactivated"];
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? ApplicationTenant.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicationUser {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["avatar"] = this.avatar;
        data["deactivated"] = this.deactivated;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IApplicationUser extends IIdentityUserOfGuid {
    firstName?: string | undefined;
    lastName?: string | undefined;
    avatar?: string | undefined;
    deactivated?: boolean;
    tenantId?: string | undefined;
    tenant?: ApplicationTenant | undefined;
}

export class ApplicationTenant implements IApplicationTenant {
    id?: string;
    name?: string | undefined;

    constructor(data?: IApplicationTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ApplicationTenant {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IApplicationTenant {
    id?: string;
    name?: string | undefined;
}

export class AssemblyPartLine implements IAssemblyPartLine {
    id?: string;
    partId?: string;
    assemblyId?: string;
    part?: ProjectPart | undefined;
    assembly?: ProjectAssembly | undefined;
    qty?: number;

    constructor(data?: IAssemblyPartLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partId = _data["partId"];
            this.assemblyId = _data["assemblyId"];
            this.part = _data["part"] ? ProjectPart.fromJS(_data["part"]) : <any>undefined;
            this.assembly = _data["assembly"] ? ProjectAssembly.fromJS(_data["assembly"]) : <any>undefined;
            this.qty = _data["qty"];
        }
    }

    static fromJS(data: any): AssemblyPartLine {
        data = typeof data === 'object' ? data : {};
        let result = new AssemblyPartLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partId"] = this.partId;
        data["assemblyId"] = this.assemblyId;
        data["part"] = this.part ? this.part.toJSON() : <any>undefined;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["qty"] = this.qty;
        return data;
    }
}

export interface IAssemblyPartLine {
    id?: string;
    partId?: string;
    assemblyId?: string;
    part?: ProjectPart | undefined;
    assembly?: ProjectAssembly | undefined;
    qty?: number;
}

export class ProjectPart implements IProjectPart {
    id?: string;
    projectId?: string;
    project?: Project | undefined;
    mark?: string | undefined;
    qty?: number;
    materialTypeId?: string | undefined;
    materialType?: MaterialType | undefined;
    materialId?: string | undefined;
    material?: Material | undefined;
    materialGradeId?: string | undefined;
    materialGrade?: MaterialGrade | undefined;
    length?: number | undefined;
    width?: number | undefined;
    thickness?: number | undefined;
    weight?: number | undefined;

    constructor(data?: IProjectPart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.mark = _data["mark"];
            this.qty = _data["qty"];
            this.materialTypeId = _data["materialTypeId"];
            this.materialType = _data["materialType"] ? MaterialType.fromJS(_data["materialType"]) : <any>undefined;
            this.materialId = _data["materialId"];
            this.material = _data["material"] ? Material.fromJS(_data["material"]) : <any>undefined;
            this.materialGradeId = _data["materialGradeId"];
            this.materialGrade = _data["materialGrade"] ? MaterialGrade.fromJS(_data["materialGrade"]) : <any>undefined;
            this.length = _data["length"];
            this.width = _data["width"];
            this.thickness = _data["thickness"];
            this.weight = _data["weight"];
        }
    }

    static fromJS(data: any): ProjectPart {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectPart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["mark"] = this.mark;
        data["qty"] = this.qty;
        data["materialTypeId"] = this.materialTypeId;
        data["materialType"] = this.materialType ? this.materialType.toJSON() : <any>undefined;
        data["materialId"] = this.materialId;
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        data["materialGradeId"] = this.materialGradeId;
        data["materialGrade"] = this.materialGrade ? this.materialGrade.toJSON() : <any>undefined;
        data["length"] = this.length;
        data["width"] = this.width;
        data["thickness"] = this.thickness;
        data["weight"] = this.weight;
        return data;
    }
}

export interface IProjectPart {
    id?: string;
    projectId?: string;
    project?: Project | undefined;
    mark?: string | undefined;
    qty?: number;
    materialTypeId?: string | undefined;
    materialType?: MaterialType | undefined;
    materialId?: string | undefined;
    material?: Material | undefined;
    materialGradeId?: string | undefined;
    materialGrade?: MaterialGrade | undefined;
    length?: number | undefined;
    width?: number | undefined;
    thickness?: number | undefined;
    weight?: number | undefined;
}

export class SurfaceFinish implements ISurfaceFinish {
    id?: string;
    code?: string | undefined;
    name?: string | undefined;
    isColoured?: boolean;
    colours?: SurfaceFinishColour[] | undefined;
    deleted?: boolean;

    constructor(data?: ISurfaceFinish) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isColoured = _data["isColoured"];
            if (Array.isArray(_data["colours"])) {
                this.colours = [] as any;
                for (let item of _data["colours"])
                    this.colours!.push(SurfaceFinishColour.fromJS(item));
            }
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): SurfaceFinish {
        data = typeof data === 'object' ? data : {};
        let result = new SurfaceFinish();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isColoured"] = this.isColoured;
        if (Array.isArray(this.colours)) {
            data["colours"] = [];
            for (let item of this.colours)
                data["colours"].push(item.toJSON());
        }
        data["deleted"] = this.deleted;
        return data;
    }
}

export interface ISurfaceFinish {
    id?: string;
    code?: string | undefined;
    name?: string | undefined;
    isColoured?: boolean;
    colours?: SurfaceFinishColour[] | undefined;
    deleted?: boolean;
}

export class SurfaceFinishColour implements ISurfaceFinishColour {
    id?: string;
    surfaceFinishId?: string;
    deleted?: boolean;
    name?: string | undefined;

    constructor(data?: ISurfaceFinishColour) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.surfaceFinishId = _data["surfaceFinishId"];
            this.deleted = _data["deleted"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SurfaceFinishColour {
        data = typeof data === 'object' ? data : {};
        let result = new SurfaceFinishColour();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["surfaceFinishId"] = this.surfaceFinishId;
        data["deleted"] = this.deleted;
        data["name"] = this.name;
        return data;
    }
}

export interface ISurfaceFinishColour {
    id?: string;
    surfaceFinishId?: string;
    deleted?: boolean;
    name?: string | undefined;
}

export class DefaultDirectoryResult implements IDefaultDirectoryResult {
    id?: string;
    name?: string | undefined;
    isFabricationDrawings?: boolean;

    constructor(data?: IDefaultDirectoryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isFabricationDrawings = _data["isFabricationDrawings"];
        }
    }

    static fromJS(data: any): DefaultDirectoryResult {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultDirectoryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isFabricationDrawings"] = this.isFabricationDrawings;
        return data;
    }
}

export interface IDefaultDirectoryResult {
    id?: string;
    name?: string | undefined;
    isFabricationDrawings?: boolean;
}

export class GetDirectoriesResult implements IGetDirectoriesResult {
    directories?: Directory[] | undefined;

    constructor(data?: IGetDirectoriesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["directories"])) {
                this.directories = [] as any;
                for (let item of _data["directories"])
                    this.directories!.push(Directory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDirectoriesResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetDirectoriesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.directories)) {
            data["directories"] = [];
            for (let item of this.directories)
                data["directories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDirectoriesResult {
    directories?: Directory[] | undefined;
}

export class Directory implements IDirectory {
    id?: string;
    name?: string | undefined;
    parentId?: string | undefined;

    constructor(data?: IDirectory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): Directory {
        data = typeof data === 'object' ? data : {};
        let result = new Directory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IDirectory {
    id?: string;
    name?: string | undefined;
    parentId?: string | undefined;
}

export class CreateDirectoryResult implements ICreateDirectoryResult {
    id?: string;
    name?: string | undefined;
    parentDirectoryId?: string | undefined;

    constructor(data?: ICreateDirectoryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentDirectoryId = _data["parentDirectoryId"];
        }
    }

    static fromJS(data: any): CreateDirectoryResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDirectoryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentDirectoryId"] = this.parentDirectoryId;
        return data;
    }
}

export interface ICreateDirectoryResult {
    id?: string;
    name?: string | undefined;
    parentDirectoryId?: string | undefined;
}

export class DeleteFilesReqeuest implements IDeleteFilesReqeuest {
    fileIds?: string[] | undefined;

    constructor(data?: IDeleteFilesReqeuest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["fileIds"])
                    this.fileIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteFilesReqeuest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFilesReqeuest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fileIds)) {
            data["fileIds"] = [];
            for (let item of this.fileIds)
                data["fileIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteFilesReqeuest {
    fileIds?: string[] | undefined;
}

export class MoveFilesRequest implements IMoveFilesRequest {
    projectId?: string;
    directories?: string[] | undefined;
    files?: string[] | undefined;
    targetDirectory?: string | undefined;

    constructor(data?: IMoveFilesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["directories"])) {
                this.directories = [] as any;
                for (let item of _data["directories"])
                    this.directories!.push(item);
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(item);
            }
            this.targetDirectory = _data["targetDirectory"];
        }
    }

    static fromJS(data: any): MoveFilesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MoveFilesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.directories)) {
            data["directories"] = [];
            for (let item of this.directories)
                data["directories"].push(item);
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        data["targetDirectory"] = this.targetDirectory;
        return data;
    }
}

export interface IMoveFilesRequest {
    projectId?: string;
    directories?: string[] | undefined;
    files?: string[] | undefined;
    targetDirectory?: string | undefined;
}

export class GetProjectResult implements IGetProjectResult {
    id?: string;
    number?: string | undefined;
    name?: string | undefined;
    address?: Address | undefined;
    assignedUser?: UserSummary | undefined;
    projectStatus?: ProjectStatus | undefined;
    customer?: Contact | undefined;
    details?: string | undefined;

    constructor(data?: IGetProjectResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.name = _data["name"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.assignedUser = _data["assignedUser"] ? UserSummary.fromJS(_data["assignedUser"]) : <any>undefined;
            this.projectStatus = _data["projectStatus"] ? ProjectStatus.fromJS(_data["projectStatus"]) : <any>undefined;
            this.customer = _data["customer"] ? Contact.fromJS(_data["customer"]) : <any>undefined;
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): GetProjectResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["projectStatus"] = this.projectStatus ? this.projectStatus.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["details"] = this.details;
        return data;
    }
}

export interface IGetProjectResult {
    id?: string;
    number?: string | undefined;
    name?: string | undefined;
    address?: Address | undefined;
    assignedUser?: UserSummary | undefined;
    projectStatus?: ProjectStatus | undefined;
    customer?: Contact | undefined;
    details?: string | undefined;
}

export class UserSummary implements IUserSummary {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IUserSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): UserSummary {
        data = typeof data === 'object' ? data : {};
        let result = new UserSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IUserSummary {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class GetProjectsResult implements IGetProjectsResult {
    projects?: Project[] | undefined;

    constructor(data?: IGetProjectsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(Project.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectsResult {
    projects?: Project[] | undefined;
}

export class UpdateProjectStatusRequest implements IUpdateProjectStatusRequest {
    statusId?: string;

    constructor(data?: IUpdateProjectStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): UpdateProjectStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface IUpdateProjectStatusRequest {
    statusId?: string;
}

export class CreateProjectResult implements ICreateProjectResult {
    id?: string;
    projectName?: string | undefined;

    constructor(data?: ICreateProjectResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): CreateProjectResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface ICreateProjectResult {
    id?: string;
    projectName?: string | undefined;
}

export class CreateProjectCommand implements ICreateProjectCommand {
    project?: ProjectData | undefined;
    address?: AddressData | undefined;
    details?: string | undefined;

    constructor(data?: ICreateProjectCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectData.fromJS(_data["project"]) : <any>undefined;
            this.address = _data["address"] ? AddressData.fromJS(_data["address"]) : <any>undefined;
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): CreateProjectCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["details"] = this.details;
        return data;
    }
}

export interface ICreateProjectCommand {
    project?: ProjectData | undefined;
    address?: AddressData | undefined;
    details?: string | undefined;
}

export class ProjectData implements IProjectData {
    name?: string | undefined;
    statusId?: string | undefined;
    number?: string | undefined;
    assignedToUser?: string | undefined;
    customerId?: string | undefined;

    constructor(data?: IProjectData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.statusId = _data["statusId"];
            this.number = _data["number"];
            this.assignedToUser = _data["assignedToUser"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): ProjectData {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["statusId"] = this.statusId;
        data["number"] = this.number;
        data["assignedToUser"] = this.assignedToUser;
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IProjectData {
    name?: string | undefined;
    statusId?: string | undefined;
    number?: string | undefined;
    assignedToUser?: string | undefined;
    customerId?: string | undefined;
}

export class AddressData implements IAddressData {
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postCode?: string | undefined;

    constructor(data?: IAddressData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.postCode = _data["postCode"];
        }
    }

    static fromJS(data: any): AddressData {
        data = typeof data === 'object' ? data : {};
        let result = new AddressData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["postCode"] = this.postCode;
        return data;
    }
}

export interface IAddressData {
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postCode?: string | undefined;
}

export class EditProjectResult implements IEditProjectResult {
    id?: string;
    projectName?: string | undefined;

    constructor(data?: IEditProjectResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): EditProjectResult {
        data = typeof data === 'object' ? data : {};
        let result = new EditProjectResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IEditProjectResult {
    id?: string;
    projectName?: string | undefined;
}

export class EditProjectCommand implements IEditProjectCommand {
    id?: string;
    project?: ProjectData2 | undefined;
    address?: AddressData2 | undefined;
    details?: string | undefined;

    constructor(data?: IEditProjectCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.project = _data["project"] ? ProjectData2.fromJS(_data["project"]) : <any>undefined;
            this.address = _data["address"] ? AddressData2.fromJS(_data["address"]) : <any>undefined;
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): EditProjectCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditProjectCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["details"] = this.details;
        return data;
    }
}

export interface IEditProjectCommand {
    id?: string;
    project?: ProjectData2 | undefined;
    address?: AddressData2 | undefined;
    details?: string | undefined;
}

export class ProjectData2 implements IProjectData2 {
    name?: string | undefined;
    number?: string | undefined;
    customerId?: string | undefined;

    constructor(data?: IProjectData2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.number = _data["number"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): ProjectData2 {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectData2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["number"] = this.number;
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IProjectData2 {
    name?: string | undefined;
    number?: string | undefined;
    customerId?: string | undefined;
}

export class AddressData2 implements IAddressData2 {
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postCode?: string | undefined;

    constructor(data?: IAddressData2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.postCode = _data["postCode"];
        }
    }

    static fromJS(data: any): AddressData2 {
        data = typeof data === 'object' ? data : {};
        let result = new AddressData2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["postCode"] = this.postCode;
        return data;
    }
}

export interface IAddressData2 {
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postCode?: string | undefined;
}

export class StockResult implements IStockResult {
    id?: string;
    code?: string | undefined;
    length?: number;
    stockLocationId?: string;
    qty?: number;
    materialId?: string;
    materialProfileId?: string;
    weight?: number;
    materialTypeId?: string;

    constructor(data?: IStockResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.length = _data["length"];
            this.stockLocationId = _data["stockLocationId"];
            this.qty = _data["qty"];
            this.materialId = _data["materialId"];
            this.materialProfileId = _data["materialProfileId"];
            this.weight = _data["weight"];
            this.materialTypeId = _data["materialTypeId"];
        }
    }

    static fromJS(data: any): StockResult {
        data = typeof data === 'object' ? data : {};
        let result = new StockResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["length"] = this.length;
        data["stockLocationId"] = this.stockLocationId;
        data["qty"] = this.qty;
        data["materialId"] = this.materialId;
        data["materialProfileId"] = this.materialProfileId;
        data["weight"] = this.weight;
        data["materialTypeId"] = this.materialTypeId;
        return data;
    }
}

export interface IStockResult {
    id?: string;
    code?: string | undefined;
    length?: number;
    stockLocationId?: string;
    qty?: number;
    materialId?: string;
    materialProfileId?: string;
    weight?: number;
    materialTypeId?: string;
}

export class AddStockDto implements IAddStockDto {
    stockLocationId?: string;
    materialId?: string;
    length?: number;
    qty?: number;

    constructor(data?: IAddStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockLocationId = _data["stockLocationId"];
            this.materialId = _data["materialId"];
            this.length = _data["length"];
            this.qty = _data["qty"];
        }
    }

    static fromJS(data: any): AddStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockLocationId"] = this.stockLocationId;
        data["materialId"] = this.materialId;
        data["length"] = this.length;
        data["qty"] = this.qty;
        return data;
    }
}

export interface IAddStockDto {
    stockLocationId?: string;
    materialId?: string;
    length?: number;
    qty?: number;
}

export class StockLocation implements IStockLocation {
    id?: string;
    parentId?: string | undefined;
    parent?: StockLocation | undefined;
    code?: string | undefined;
    deleted?: boolean;

    constructor(data?: IStockLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? StockLocation.fromJS(_data["parent"]) : <any>undefined;
            this.code = _data["code"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): StockLocation {
        data = typeof data === 'object' ? data : {};
        let result = new StockLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["deleted"] = this.deleted;
        return data;
    }
}

export interface IStockLocation {
    id?: string;
    parentId?: string | undefined;
    parent?: StockLocation | undefined;
    code?: string | undefined;
    deleted?: boolean;
}

export class UpdateStockLocationRequest implements IUpdateStockLocationRequest {
    parentId?: string | undefined;
    code?: string | undefined;

    constructor(data?: IUpdateStockLocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): UpdateStockLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStockLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        return data;
    }
}

export interface IUpdateStockLocationRequest {
    parentId?: string | undefined;
    code?: string | undefined;
}

export class CreateStockLocationRequest implements ICreateStockLocationRequest {
    parentId?: string | undefined;
    code?: string | undefined;

    constructor(data?: ICreateStockLocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CreateStockLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStockLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        return data;
    }
}

export interface ICreateStockLocationRequest {
    parentId?: string | undefined;
    code?: string | undefined;
}

export class Supplier implements ISupplier {
    id?: string;
    name?: string | undefined;

    constructor(data?: ISupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Supplier {
        data = typeof data === 'object' ? data : {};
        let result = new Supplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISupplier {
    id?: string;
    name?: string | undefined;
}

export class Colour implements IColour {
    name?: string | undefined;

    constructor(data?: IColour) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Colour {
        data = typeof data === 'object' ? data : {};
        let result = new Colour();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IColour {
    name?: string | undefined;
}

export class GetTasksResult implements IGetTasksResult {
    tasks?: Task[] | undefined;

    constructor(data?: IGetTasksResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(Task.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTasksResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetTasksResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTasksResult {
    tasks?: Task[] | undefined;
}

export abstract class EntityObject implements IEntityObject {
    id?: string;
    createdAt?: Date;
    createdByUserId?: string | undefined;
    createdByUser?: ApplicationUser | undefined;
    modifiedAt?: Date;
    modifiedByUserId?: string | undefined;
    modifiedByUser?: ApplicationUser | undefined;

    constructor(data?: IEntityObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdByUserId = _data["createdByUserId"];
            this.createdByUser = _data["createdByUser"] ? ApplicationUser.fromJS(_data["createdByUser"]) : <any>undefined;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : <any>undefined;
            this.modifiedByUserId = _data["modifiedByUserId"];
            this.modifiedByUser = _data["modifiedByUser"] ? ApplicationUser.fromJS(_data["modifiedByUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdByUserId"] = this.createdByUserId;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : <any>undefined;
        data["modifiedByUserId"] = this.modifiedByUserId;
        data["modifiedByUser"] = this.modifiedByUser ? this.modifiedByUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEntityObject {
    id?: string;
    createdAt?: Date;
    createdByUserId?: string | undefined;
    createdByUser?: ApplicationUser | undefined;
    modifiedAt?: Date;
    modifiedByUserId?: string | undefined;
    modifiedByUser?: ApplicationUser | undefined;
}

export class Task extends EntityObject implements ITask {
    title?: string | undefined;
    projectId?: string | undefined;
    project?: Project | undefined;
    statusId?: string | undefined;
    status?: TaskStatus | undefined;
    assignedToUserId?: string | undefined;
    assignedToUser?: ApplicationUser | undefined;
    description?: string | undefined;
    comments?: TaskComment[] | undefined;
    startDate?: Date;
    endDate?: Date;
    attachments?: TaskAttachment[] | undefined;
    assignments?: TaskAssignment[] | undefined;
    workLog?: WorkLogEntry[] | undefined;

    constructor(data?: ITask) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? TaskStatus.fromJS(_data["status"]) : <any>undefined;
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUser = _data["assignedToUser"] ? ApplicationUser.fromJS(_data["assignedToUser"]) : <any>undefined;
            this.description = _data["description"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(TaskComment.fromJS(item));
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(TaskAttachment.fromJS(item));
            }
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(TaskAssignment.fromJS(item));
            }
            if (Array.isArray(_data["workLog"])) {
                this.workLog = [] as any;
                for (let item of _data["workLog"])
                    this.workLog!.push(WorkLogEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Task {
        data = typeof data === 'object' ? data : {};
        let result = new Task();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUser"] = this.assignedToUser ? this.assignedToUser.toJSON() : <any>undefined;
        data["description"] = this.description;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item.toJSON());
        }
        if (Array.isArray(this.workLog)) {
            data["workLog"] = [];
            for (let item of this.workLog)
                data["workLog"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITask extends IEntityObject {
    title?: string | undefined;
    projectId?: string | undefined;
    project?: Project | undefined;
    statusId?: string | undefined;
    status?: TaskStatus | undefined;
    assignedToUserId?: string | undefined;
    assignedToUser?: ApplicationUser | undefined;
    description?: string | undefined;
    comments?: TaskComment[] | undefined;
    startDate?: Date;
    endDate?: Date;
    attachments?: TaskAttachment[] | undefined;
    assignments?: TaskAssignment[] | undefined;
    workLog?: WorkLogEntry[] | undefined;
}

export class TaskStatus implements ITaskStatus {
    id?: string;
    name?: string | undefined;
    colour?: string | undefined;

    constructor(data?: ITaskStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.colour = _data["colour"];
        }
    }

    static fromJS(data: any): TaskStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TaskStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["colour"] = this.colour;
        return data;
    }
}

export interface ITaskStatus {
    id?: string;
    name?: string | undefined;
    colour?: string | undefined;
}

export class TaskComment extends EntityObject implements ITaskComment {
    commentForId?: string;
    commentFor?: Task | undefined;
    contents?: string | undefined;

    constructor(data?: ITaskComment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.commentForId = _data["commentForId"];
            this.commentFor = _data["commentFor"] ? Task.fromJS(_data["commentFor"]) : <any>undefined;
            this.contents = _data["contents"];
        }
    }

    static fromJS(data: any): TaskComment {
        data = typeof data === 'object' ? data : {};
        let result = new TaskComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentForId"] = this.commentForId;
        data["commentFor"] = this.commentFor ? this.commentFor.toJSON() : <any>undefined;
        data["contents"] = this.contents;
        super.toJSON(data);
        return data;
    }
}

export interface ITaskComment extends IEntityObject {
    commentForId?: string;
    commentFor?: Task | undefined;
    contents?: string | undefined;
}

export class TaskAttachment extends EntityObject implements ITaskAttachment {
    attachmentForId?: string;
    attachmentFor?: Task | undefined;

    constructor(data?: ITaskAttachment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.attachmentForId = _data["attachmentForId"];
            this.attachmentFor = _data["attachmentFor"] ? Task.fromJS(_data["attachmentFor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentForId"] = this.attachmentForId;
        data["attachmentFor"] = this.attachmentFor ? this.attachmentFor.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITaskAttachment extends IEntityObject {
    attachmentForId?: string;
    attachmentFor?: Task | undefined;
}

export class TaskAssignment extends EntityObject implements ITaskAssignment {
    users?: TaskAssignmentUser[] | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    comments?: string | undefined;

    constructor(data?: ITaskAssignment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(TaskAssignmentUser.fromJS(item));
            }
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): TaskAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        super.toJSON(data);
        return data;
    }
}

export interface ITaskAssignment extends IEntityObject {
    users?: TaskAssignmentUser[] | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    comments?: string | undefined;
}

export class TaskAssignmentUser extends EntityObject implements ITaskAssignmentUser {
    taskAssignmentId?: string;
    taskAssignment?: TaskAssignment | undefined;
    userId?: string;
    user?: ApplicationUser | undefined;

    constructor(data?: ITaskAssignmentUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taskAssignmentId = _data["taskAssignmentId"];
            this.taskAssignment = _data["taskAssignment"] ? TaskAssignment.fromJS(_data["taskAssignment"]) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? ApplicationUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskAssignmentUser {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAssignmentUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskAssignmentId"] = this.taskAssignmentId;
        data["taskAssignment"] = this.taskAssignment ? this.taskAssignment.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITaskAssignmentUser extends IEntityObject {
    taskAssignmentId?: string;
    taskAssignment?: TaskAssignment | undefined;
    userId?: string;
    user?: ApplicationUser | undefined;
}

export class WorkLogEntry implements IWorkLogEntry {
    id?: string;
    projectId?: string;
    users?: WorkLogEntryUser[] | undefined;
    date?: Date;
    startTime?: string;
    endTime?: string;
    details?: string | undefined;
    attachments?: WorkLogEntryFile[] | undefined;
    taskId?: string | undefined;
    task?: Task | undefined;

    constructor(data?: IWorkLogEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(WorkLogEntryUser.fromJS(item));
            }
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.details = _data["details"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(WorkLogEntryFile.fromJS(item));
            }
            this.taskId = _data["taskId"];
            this.task = _data["task"] ? Task.fromJS(_data["task"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkLogEntry {
        data = typeof data === 'object' ? data : {};
        let result = new WorkLogEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["details"] = this.details;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["taskId"] = this.taskId;
        data["task"] = this.task ? this.task.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWorkLogEntry {
    id?: string;
    projectId?: string;
    users?: WorkLogEntryUser[] | undefined;
    date?: Date;
    startTime?: string;
    endTime?: string;
    details?: string | undefined;
    attachments?: WorkLogEntryFile[] | undefined;
    taskId?: string | undefined;
    task?: Task | undefined;
}

export class WorkLogEntryUser implements IWorkLogEntryUser {
    workLogEntryId?: string;
    userId?: string;
    entry?: WorkLogEntry | undefined;
    user?: ApplicationUser | undefined;

    constructor(data?: IWorkLogEntryUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workLogEntryId = _data["workLogEntryId"];
            this.userId = _data["userId"];
            this.entry = _data["entry"] ? WorkLogEntry.fromJS(_data["entry"]) : <any>undefined;
            this.user = _data["user"] ? ApplicationUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkLogEntryUser {
        data = typeof data === 'object' ? data : {};
        let result = new WorkLogEntryUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workLogEntryId"] = this.workLogEntryId;
        data["userId"] = this.userId;
        data["entry"] = this.entry ? this.entry.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWorkLogEntryUser {
    workLogEntryId?: string;
    userId?: string;
    entry?: WorkLogEntry | undefined;
    user?: ApplicationUser | undefined;
}

export class WorkLogEntryFile implements IWorkLogEntryFile {
    workLogEntryId?: string;
    projectFileId?: string;
    entry?: WorkLogEntry | undefined;
    file?: ProjectFile | undefined;

    constructor(data?: IWorkLogEntryFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workLogEntryId = _data["workLogEntryId"];
            this.projectFileId = _data["projectFileId"];
            this.entry = _data["entry"] ? WorkLogEntry.fromJS(_data["entry"]) : <any>undefined;
            this.file = _data["file"] ? ProjectFile.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkLogEntryFile {
        data = typeof data === 'object' ? data : {};
        let result = new WorkLogEntryFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workLogEntryId"] = this.workLogEntryId;
        data["projectFileId"] = this.projectFileId;
        data["entry"] = this.entry ? this.entry.toJSON() : <any>undefined;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWorkLogEntryFile {
    workLogEntryId?: string;
    projectFileId?: string;
    entry?: WorkLogEntry | undefined;
    file?: ProjectFile | undefined;
}

export class CreateTaskCommandResult implements ICreateTaskCommandResult {

    constructor(data?: ICreateTaskCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateTaskCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaskCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICreateTaskCommandResult {
}

export class CreateTaskCommand implements ICreateTaskCommand {
    name?: string | undefined;
    projectId?: string | undefined;
    statusId?: string | undefined;

    constructor(data?: ICreateTaskCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): CreateTaskCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaskCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface ICreateTaskCommand {
    name?: string | undefined;
    projectId?: string | undefined;
    statusId?: string | undefined;
}

export class GetTaskStatusesResult implements IGetTaskStatusesResult {
    statuses?: TaskStatus[] | undefined;

    constructor(data?: IGetTaskStatusesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(TaskStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTaskStatusesResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskStatusesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTaskStatusesResult {
    statuses?: TaskStatus[] | undefined;
}

export class CreateTenantResult implements ICreateTenantResult {
    id?: string;
    name?: string | undefined;

    constructor(data?: ICreateTenantResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateTenantResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateTenantResult {
    id?: string;
    name?: string | undefined;
}

export class CreateTenantRequest implements ICreateTenantRequest {
    name?: string | undefined;

    constructor(data?: ICreateTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateTenantRequest {
    name?: string | undefined;
}

export class GetUserResult implements IGetUserResult {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isActive?: boolean;
    emailConfirmed?: boolean;
    isAdmin?: boolean;

    constructor(data?: IGetUserResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): GetUserResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        data["emailConfirmed"] = this.emailConfirmed;
        data["isAdmin"] = this.isAdmin;
        return data;
    }
}

export interface IGetUserResult {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isActive?: boolean;
    emailConfirmed?: boolean;
    isAdmin?: boolean;
}

export class UpdateUserResult implements IUpdateUserResult {

    constructor(data?: IUpdateUserResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateUserResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateUserResult {
}

export class UpdateUserRequest implements IUpdateUserRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isAdmin?: boolean;

    constructor(data?: IUpdateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): UpdateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isAdmin"] = this.isAdmin;
        return data;
    }
}

export interface IUpdateUserRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isAdmin?: boolean;
}

export class GetUsersResult implements IGetUsersResult {
    users?: User[] | undefined;

    constructor(data?: IGetUsersResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUsersResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUsersResult {
    users?: User[] | undefined;
}

export class User implements IUser {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isActive?: boolean;
    emailConfirmed?: boolean;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            this.emailConfirmed = _data["emailConfirmed"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        data["emailConfirmed"] = this.emailConfirmed;
        return data;
    }
}

export interface IUser {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isActive?: boolean;
    emailConfirmed?: boolean;
}

export class InviteUserResponse implements IInviteUserResponse {
    error?: boolean;

    constructor(data?: IInviteUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): InviteUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InviteUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

export interface IInviteUserResponse {
    error?: boolean;
}

export class InviteUserRequest implements IInviteUserRequest {
    tenantId!: string;
    firstName!: string;
    lastName!: string;
    emailAddress!: string;
    phoneNumber?: string | undefined;

    constructor(data?: IInviteUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): InviteUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviteUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IInviteUserRequest {
    tenantId: string;
    firstName: string;
    lastName: string;
    emailAddress: string;
    phoneNumber?: string | undefined;
}

export class WorkLogEntrySummary implements IWorkLogEntrySummary {
    attachments?: FileSummary[] | undefined;
    id?: string;
    date?: Date;
    startTime?: string;
    endTime?: string;
    details?: string | undefined;
    users?: UserSummary[] | undefined;

    constructor(data?: IWorkLogEntrySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(FileSummary.fromJS(item));
            }
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.details = _data["details"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkLogEntrySummary {
        data = typeof data === 'object' ? data : {};
        let result = new WorkLogEntrySummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["details"] = this.details;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWorkLogEntrySummary {
    attachments?: FileSummary[] | undefined;
    id?: string;
    date?: Date;
    startTime?: string;
    endTime?: string;
    details?: string | undefined;
    users?: UserSummary[] | undefined;
}

export class FileSummary implements IFileSummary {
    id?: string;
    fileName?: string | undefined;
    url?: string | undefined;

    constructor(data?: IFileSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): FileSummary {
        data = typeof data === 'object' ? data : {};
        let result = new FileSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["url"] = this.url;
        return data;
    }
}

export interface IFileSummary {
    id?: string;
    fileName?: string | undefined;
    url?: string | undefined;
}

export class GetWorkDiaryEntryResponse implements IGetWorkDiaryEntryResponse {
    id?: string;
    users?: UserDto[] | undefined;
    projectId?: string;
    date?: Date;
    details?: string | undefined;
    startTime?: string;
    endTime?: string;

    constructor(data?: IGetWorkDiaryEntryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDto.fromJS(item));
            }
            this.projectId = _data["projectId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.details = _data["details"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
        }
    }

    static fromJS(data: any): GetWorkDiaryEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorkDiaryEntryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["projectId"] = this.projectId;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["details"] = this.details;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        return data;
    }
}

export interface IGetWorkDiaryEntryResponse {
    id?: string;
    users?: UserDto[] | undefined;
    projectId?: string;
    date?: Date;
    details?: string | undefined;
    startTime?: string;
    endTime?: string;
}

export class UserDto implements IUserDto {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IUserDto {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class CreateWorkLogEntryResponse implements ICreateWorkLogEntryResponse {
    entry?: WorkLogEntry | undefined;

    constructor(data?: ICreateWorkLogEntryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entry = _data["entry"] ? WorkLogEntry.fromJS(_data["entry"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateWorkLogEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkLogEntryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entry"] = this.entry ? this.entry.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateWorkLogEntryResponse {
    entry?: WorkLogEntry | undefined;
}

export class UpdateWorkDiaryEntryResponse implements IUpdateWorkDiaryEntryResponse {

    constructor(data?: IUpdateWorkDiaryEntryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateWorkDiaryEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkDiaryEntryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateWorkDiaryEntryResponse {
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}